import React, { useCallback, useMemo } from 'react'

import { renderers } from '@markdoc/markdoc'

import { Layout } from './components/Layout'
import { collectHeadings, parseHtml } from './utils'
import { Fence } from '~/portal/components/SyntaxRenderer/components/Fence'
import { Heading } from '~/portal/components/SyntaxRenderer/components/Heading'
import { MarkdownLink as Link } from '~/portal/components/SyntaxRenderer/components/Link'
import { StreamingBadge } from '~/portal/components/SyntaxRenderer/components/StreamingBadge'
import { Table } from '~/portal/components/SyntaxRenderer/components/Table'
import { CONTENT_TYPE } from '~/shared/types/content'

interface SyntaxRendererProps {
  content: any,
  title?: string,
  lastModifiedDate?: string,
  providerContentSlug?: string,
  showEditButtons?: boolean,
  type?: CONTENT_TYPE,
  props?: any,
  isConsumerSide?: boolean,
  useMarkdocRenderer?: boolean,
}

export const SyntaxRenderer = ({
  content,
  title,
  lastModifiedDate,
  providerContentSlug,
  showEditButtons = false,
  type = CONTENT_TYPE.HTML,
  isConsumerSide = false,
  useMarkdocRenderer = false,
  ...props
}: SyntaxRendererProps) => {

  const htmlNodes = useCallback(() => parseHtml(content), [content])

  const markdocComponents = useMemo(() => ({
    Fence,
    Table,
    Link,
    StreamingBadge,
    Heading: (headingProps: React.ComponentProps<typeof Heading>) => <Heading {...headingProps} contentType={type} />,
  }), [type])

  const nodes = (type === CONTENT_TYPE.HTML && !useMarkdocRenderer) ? htmlNodes() : content

  return (
    <Layout
      title={title}
      tableOfContents={content ? collectHeadings({ nodes, type, useMarkdocRenderer }) : []}
      lastModifiedDate={lastModifiedDate}
      providerContentSlug={providerContentSlug}
      showEditButtons={showEditButtons}
      useMarkdocRenderer={useMarkdocRenderer}
      isConsumerSide={isConsumerSide}
      {...props}>
      {(type === CONTENT_TYPE.MARKDOWN || useMarkdocRenderer) && renderers.react(
        content,
        React,
        {
          components: markdocComponents
        }
      )}
      {type === CONTENT_TYPE.HTML && htmlNodes()}
    </Layout>
  ) 
}